module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title2"
  }, [_c('a', {
    attrs: {
      "id": "page-xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/toc#toc-preface003",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because “ch” is generally pronounced as an “h” in Gaelic, the Highland name Sorcha sounds like Sarah, rather than being phonetically pronounced. Sidony is Sidney. Kilchurn Castle is Kill-HERN. Dail Righ is Dal-REE.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690e8039","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface003.vue
// module id = 69
// module chunks = 0